import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { useSearchParams } from 'react-router-dom';

import { DonorScheduleDonorLink } from '@/components/common/links';
import { PulledSemenItem, ScheduledDonorItem } from '@/services/semen-pull';

import { useScheduledDonorsQuery } from '../../../services/semen-pull/hooks';

type Props = {
  rowData: PulledSemenItem;
};
export const DonorsScheduledPulledGrid = ({ rowData }: Props) => {
  const [params] = useSearchParams();
  const selectedDate = params.get('date');
  const selectedSiteId = params.get('site');

  const { data: scheduledDonors } = useScheduledDonorsQuery({
    date: selectedDate,
    siteId: selectedSiteId,
    sireId: rowData.sireId,
    semenId: rowData.semenId,
    accountId: rowData.accountId,
    semenType: rowData.semenTypeName,
    dsSemenLocId: rowData.semenStorageId,
  });

  return (
    <div className="donors-scheduled-grid">
      <DataTable value={scheduledDonors as ScheduledDonorItem[]}>
        <Column
          field="donorName"
          header="Donor"
          body={(rowData: ScheduledDonorItem) => (
            <DonorScheduleDonorLink
              donorScheduleId={rowData.donorScheduleID as string}
              donorName={rowData.donorName as string}
            />
          )}
        ></Column>
        <Column field="csr" header="CSR"></Column>
      </DataTable>
    </div>
  );
};
